import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/apiService";


export const GetAllAdministrativeCostsCommentsByStagesGuid = createAsyncThunk(
  "dropdowns/GetAllAdministrativeCostsCommentsByStagesGuid",
  async (parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/AdministrativeCostsComments/GetAllPR_DistributionAdministrativeCostsCommentsByPR_ReportsStagesGuid",parameter);

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "agegrop");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const AddAdministrativeCostsComments = createAsyncThunk(
    "dropdowns/AddAdministrativeCostsComments",
    async (parameter, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post("api/AdministrativeCostsComments/AddPR_DistributionAdministrativeCostsComments",parameter);
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        console.log(data, "agegrop");
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );


const AdministrativeCostsComments = createSlice({
  name: "PR_AgeGroupDropDown",
  initialState: {
    AdministrativeCostsCommentsLists: [],
    loadingAdministrativeCostsCommentsLists: false,
    errorAdministrativeCostsCommentsLists: null,

    AddAdministrativeCostsComments: [],
    loadingAddAdministrativeCostsComments: false,
    errorAddAdministrativeCostsComments: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllAdministrativeCostsCommentsByStagesGuid.pending, (state, action) => {
        state.loadingAdministrativeCostsCommentsLists = true;
        state.AdministrativeCostsCommentsLists = action.payload;
        state.errorAdministrativeCostsCommentsLists = null;
      })
      .addCase(GetAllAdministrativeCostsCommentsByStagesGuid.fulfilled, (state, action) => {
        state.loadingAdministrativeCostsCommentsLists = false;
        state.AdministrativeCostsCommentsLists = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllAdministrativeCostsCommentsByStagesGuid.rejected, (state, action) => {
        state.loadingAdministrativeCostsCommentsLists = false;
        state.AdministrativeCostsCommentsLists = action.payload;
      });

      ///////////////////////////////////////////////////////////////
      builder
      .addCase(AddAdministrativeCostsComments.pending, (state, action) => {
        state.loadingAddAdministrativeCostsComments = true;
        state.AddAdministrativeCostsComments = action.payload;
        state.errorAddAdministrativeCostsComments = null;
      })
      .addCase(AddAdministrativeCostsComments.fulfilled, (state, action) => {
        state.loadingAddAdministrativeCostsComments = false;
        state.AddAdministrativeCostsComments = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddAdministrativeCostsComments.rejected, (state, action) => {
        state.loadingAddAdministrativeCostsComments = false;
        state.AdministrativeCostsCommentsLists = action.payload;
      });
  },
});

export default AdministrativeCostsComments.reducer;
